module.exports = __webpack_public_path__ + "img/map-contatti.a5eb34ba.png";